import {Component, Input, OnInit} from "@angular/core";
import {Article} from "../../../models/article.model";

@Component({
    selector: 'catalogue-article-attributes',
    templateUrl: './article-attributes.component.html',
})
export class ArticleAttributesComponent implements OnInit {

    @Input() public article: Article;

    public ngOnInit() {

    }
}
